import { useEffect } from 'react';
import './welcome.css';
import { WelcomeProvider } from './WelcomeContext';
import WelcomeWizard from './WelcomeWizard';
import { sanitizeRedirectPath } from '@arthelper/shared/safe-redirect';

/** sessionStorage key for the town-square path to return to after the wizard. */
export const WELCOME_RETURN_TO_KEY = 'welcome:returnTo';

export default function WelcomePage() {
  // A referred signup arrives as /welcome?redirect_url=<town-square path> (forwarded
  // by the onboarding gate). Capture it once — the wizard may navigate internally and
  // the Done step needs it at the very end.
  useEffect(() => {
    const raw = new URLSearchParams(window.location.search).get('redirect_url');
    const safe = sanitizeRedirectPath(raw, undefined);
    if (safe && safe !== '/') {
      try {
        sessionStorage.setItem(WELCOME_RETURN_TO_KEY, safe);
      } catch {
        // storage unavailable — the query param may still be alive at Done
      }
    }
  }, []);

  return (
    <WelcomeProvider>
      <WelcomeWizard />
    </WelcomeProvider>
  );
}
